export const UPDATE_PROJECT_REPLICATIONS = "UPDATE_PROJECT_REPLICATIONS";
export const updateProjectReplications = (payload) => ({
  type: UPDATE_PROJECT_REPLICATIONS,
  payload,
});

export const UPDATE_REPLICATION_STATUS = "UPDATE_REPLICATION_STATUS";
export const updateReplicationStatus = (payload) => ({
  type: UPDATE_REPLICATION_STATUS,
  payload,
});

export const GET_PROJECT_REPLICATION_STATUS = "GET_PROJECT_REPLICATION_STATUS";
export const getProjectReplicationStatus = (payload) => ({
  type: GET_PROJECT_REPLICATION_STATUS,
  payload,
});

export const GET_PROJECT_REPLICATION_STATUS_SUCCESS = "GET_PROJECT_REPLICATION_STATUS_SUCCESS";
export const getProjectReplicationStatusSuccess = (payload) => ({
  type: GET_PROJECT_REPLICATION_STATUS_SUCCESS,
  payload,
});

export const GET_PROJECT_REPLICATIONS = "GET_PROJECT_REPLICATIONS";
export const getProjectReplications = (payload) => ({
  type: GET_PROJECT_REPLICATIONS,
  payload,
});

export const GET_PROJECT_REPLICATIONS_SUCCESS = "GET_PROJECT_REPLICATIONS_SUCCESS";
export const getProjectReplicationsSuccess = (payload) => ({
  type: GET_PROJECT_REPLICATIONS_SUCCESS,
  payload,
});

export const GET_PROJECT_TAB_PLANTS = "GET_PROJECT_TAB_PLANTS";
export const getProjectTabPlants = (payload) => ({
  type: GET_PROJECT_TAB_PLANTS,
  payload,
});

export const GET_PROJECT_TAB_PLANTS_SUCCESS = "GET_PROJECT_TAB_PLANTS_SUCCESS";
export const getProjectTabPlantsSuccess = (payload) => ({
  type: GET_PROJECT_TAB_PLANTS_SUCCESS,
  payload,
});

export const UPDATE_PROJECT_FIELD_GROUPS = "UPDATE_PROJECT_FIELD_GROUPS";
export const updateProjectFieldGroups = (payload) => ({
  type: UPDATE_PROJECT_FIELD_GROUPS,
  payload,
});

export const GET_PROJECT_FIELD_GROUPS = "GET_PROJECT_FIELD_GROUPS";
export const getProjectFieldGroups = (payload) => ({
  type: GET_PROJECT_FIELD_GROUPS,
  payload,
});

export const GET_PROJECT_FIELD_GROUPS_SUCCESS = "GET_PROJECT_FIELD_GROUPS_SUCCESS";
export const getProjectFieldGroupsSuccess = (payload) => ({
  type: GET_PROJECT_FIELD_GROUPS_SUCCESS,
  payload,
});

export const PROJECT_RATING_SET = "PROJECT_RATING_SET";
export const projectRatingSet = (payload) => ({
  type: PROJECT_RATING_SET,
  payload,
});

export const PROJECT_RATING_SET_SUCCESS = "PROJECT_RATING_SET_SUCCESS";
export const projectRatingSetSuccess = (payload) => ({
  type: PROJECT_RATING_SET_SUCCESS,
  payload,
});

export const PROJECT_SET_DOWNLOAD_PARAMS = "PROJECT_SET_DOWNLOAD_PARAMS";
export const projectSetDownloadParams = (payload) => ({
  type: PROJECT_SET_DOWNLOAD_PARAMS,
  payload,
});

export const PROJECT_SELECTED_SET = "PROJECT_SELECTED_SET";
export const projectSet = (payload) => ({
  type: PROJECT_SELECTED_SET,
  payload,
});

export const PROJECT_LIST_GET_ATTEMPT = "PROJECT_LIST_GET_ATTEMPT";
export const projectListGet = (payload) => ({
  type: PROJECT_LIST_GET_ATTEMPT,
  payload,
});
export const PROJECT_LIST_GET_SUCCESS = "PROJECT_LIST_GET_SUCCESS";
export const projectListGetSuccess = (payload) => ({
  type: PROJECT_LIST_GET_SUCCESS,
  payload,
});

export const PROJECT_GET_ATTEMPT = "PROJECT_GET_ATTEMPT";
export const projectGet = (payload) => ({ type: PROJECT_GET_ATTEMPT, payload });
export const PROJECT_GET_SUCCESS = "PROJECT_GET_SUCCESS";
export const projectGetSuccess = (payload) => ({
  type: PROJECT_GET_SUCCESS,
  payload,
});
export const CLEAR_SELECTED_PROJECT = "CLEAR_SELECTED_PROJECT";
export const clearSelectedProject = (payload) => ({
  type: CLEAR_SELECTED_PROJECT,
  payload,
});

export const PROJECT_ACTIVITIES_GET_ATTEMPT = "PROJECT_ACTIVITIES_GET_ATTEMPT";
export const projectActivitiesGet = (payload) => ({
  type: PROJECT_ACTIVITIES_GET_ATTEMPT,
  payload,
});
export const PROJECT_ACTIVITIES_GET_SUCCESS = "PROJECT_ACTIVITIES_GET_SUCCESS";
export const projectActivitiesGetSuccess = (payload) => ({
  type: PROJECT_ACTIVITIES_GET_SUCCESS,
  payload,
});

export const PROJECT_NEW_ATTEMPT = "PROJECT_NEW_ATTEMPT";
export const projectNew = (payload) => ({ type: PROJECT_NEW_ATTEMPT, payload });
export const PROJECT_NEW_SUCCESS = "PROJECT_NEW_SUCCESS";
export const projectNewSuccess = (payload) => ({
  type: PROJECT_NEW_SUCCESS,
  payload,
});

export const CLEAR_NEW_PROJECT = "CLEAR_NEW_PROJECT";
export const clearNewProject = (payload) => ({
  type: CLEAR_NEW_PROJECT,
  payload,
});

export const PROJECT_PUT_ATTEMPT = "PROJECT_PUT_ATTEMPT";
export const projectPut = (payload) => ({ type: PROJECT_PUT_ATTEMPT, payload });
export const PROJECT_PUT_SUCCESS = "PROJECT_PUT_SUCCESS";
export const projectPutSuccess = (payload) => ({
  type: PROJECT_PUT_SUCCESS,
  payload,
});

export const PROJECT_RATINGS_GET_ATTEMPT = "PROJECT_RATINGS_GET_ATTEMPT";
export const projectRatingGet = (payload) => ({
  type: PROJECT_RATINGS_GET_ATTEMPT,
  payload,
});
export const PROJECT_RATINGS_GET_SUCCESS = "PROJECT_RATINGS_GET_SUCCESS";
export const projectRatingGetSuccess = (payload) => ({
  type: PROJECT_RATINGS_GET_SUCCESS,
  payload,
});

export const PROJECT_INDUSTRIES_LIST_ATTEMPT = "PROJECT_INDUSTRIES_LIST_ATTEMPT";
export const projectIndustriesGet = (payload) => ({
  type: PROJECT_INDUSTRIES_LIST_ATTEMPT,
  payload,
});
export const PROJECT_INDUSTRIES_LIST_SUCCESS = "PROJECT_INDUSTRIES_LIST_SUCCESS";
export const projectIndustriesSuccess = (payload) => ({
  type: PROJECT_INDUSTRIES_LIST_SUCCESS,
  payload,
});

export const PROJECT_TOPICS_LIST_ATTEMPT = "PROJECT_TOPICS_LIST_ATTEMPT";
export const projectTopicsGet = (payload) => ({
  type: PROJECT_TOPICS_LIST_ATTEMPT,
  payload,
});
export const PROJECT_TOPICS_LIST_SUCCESS = "PROJECT_TOPICS_LIST_SUCCESS";
export const projectTopicsSuccess = (payload) => ({
  type: PROJECT_TOPICS_LIST_SUCCESS,
  payload,
});

export const SET_TEMP_PROJECT_MEMBERS = "SET_TEMP_PROJECT_MEMBERS";
export const setProjectTempMembers = (payload) => ({
  type: SET_TEMP_PROJECT_MEMBERS,
  payload,
});

export const PROJECT_DELETE_ATTEMPT = "PROJECT_DELETE_ATTEMPT";
export const projectDelete = (payload) => ({
  type: PROJECT_DELETE_ATTEMPT,
  payload,
});
export const PROJECT_DELETE_SUCCESS = "PROJECT_DELETE_SUCCESS";
export const projectDeleteSuccess = (payload) => ({
  type: PROJECT_DELETE_SUCCESS,
  payload,
});

export const PROJECT_DELETE_MEMBER_ATTEMPT = "PROJECT_DELETE_MEMBER_ATTEMPT";
export const projectDeleteMember = (payload) => ({
  type: PROJECT_DELETE_MEMBER_ATTEMPT,
  payload,
});
export const PROJECT_DELETE_MEMBER_SUCCESS = "PROJECT_DELETE_MEMBER_SUCCESS";
export const projectDeleteMemberSuccess = (payload) => ({
  type: PROJECT_DELETE_MEMBER_SUCCESS,
  payload,
});

export const PROJECT_MAKE_MEMBER_OWNER_ATTEMPT = "PROJECT_MAKE_MEMBER_OWNER_ATTEMPT";
export const makeMemberOwner = (payload) => ({
  type: PROJECT_MAKE_MEMBER_OWNER_ATTEMPT,
  payload,
});

export const PROJECT_MAKE_MEMBER_OWNER_SUCCESS = "PROJECT_MAKE_MEMBER_OWNER_SUCCESS";
export const makeMemberOwnerSuccess = (payload) => ({
  type: PROJECT_MAKE_MEMBER_OWNER_SUCCESS,
});

export const ADD_COMPANY_TO_PROJECT_ATTEMPT = "ADD_COMPANY_TO_PROJECT_ATTEMPT";
export const addCompanyToProject = (payload) => ({
  type: ADD_COMPANY_TO_PROJECT_ATTEMPT,
  payload,
});
export const ADD_COMPANY_TO_PROJECT_SUCCESS = "ADD_COMPANY_TO_PROJECT_SUCCESS";
export const addCompanyToProjectSuccess = (payload) => ({
  type: ADD_COMPANY_TO_PROJECT_SUCCESS,
  payload,
});

export const PROJECT_LIST_GET_BY_ID_ATTEMPT = "PROJECT_LIST_GET_BY_ID_ATTEMPT";
export const projectListGetById = (payload) => ({
  type: PROJECT_LIST_GET_BY_ID_ATTEMPT,
  payload,
});
export const PROJECT_LIST_GET_BY_ID_SUCCESS = "PROJECT_LIST_GET_BY_ID_SUCCESS";
export const projectListGetByIdSuccess = (payload) => ({
  type: PROJECT_LIST_GET_BY_ID_SUCCESS,
  payload,
});
export const CLEAR_SELECTED_MEMBER = "CLEAR_SELECTED_MEMBER";
export const clearSelectedMember = (payload) => ({
  type: CLEAR_SELECTED_MEMBER,
  payload,
});

export const CREATE_PROJECT_DISCUSSION = "CREATE_PROJECT_DISCUSSION";
export const createProjectDiscussion = (payload) => ({
  type: CREATE_PROJECT_DISCUSSION,
  payload,
});
export const CREATE_PROJECT_DISCUSSION_SUCCESS = "CREATE_PROJECT_DISCUSSION_SUCCESS";
export const createProjectDiscussionSuccess = (payload) => ({
  type: CREATE_PROJECT_DISCUSSION_SUCCESS,
  payload,
});

export const RESET_PROJECTS_LOADING = "RESET_PROJECTS_LOADING";
export const resetProjectsLoading = (payload) => ({
  type: RESET_PROJECTS_LOADING,
  payload,
});

export const CLEAR_PROJECT_LIST = "CLEAR_PROJECT_LIST";
export const clearProjectList = (payload) => ({
  type: CLEAR_PROJECT_LIST,
  payload,
});

export const ERROR_CATCH = "ERROR_CATCH";
export const errorCatch = (payload) => ({
  type: ERROR_CATCH,
  payload,
});
